// angular import
import { OnInit, Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoadingService } from './tabms/services/loading/loading.service';
import { delay } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SessionWrapperService } from './tabms/services/session/session-wrapper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // public props
  isSpinnerVisible = true;

  // constructor
  constructor(
    private router: Router,
    private _loading: LoadingService,
    private translate: TranslateService,
    private sessionService: SessionWrapperService
  ) {
      const defaultLang = 'ar'; // أو 'en' حسب لغتك الافتراضية
      this.translate.setDefaultLang(defaultLang);

      // تحميل الترجمة والبدء
      this.translate.use(defaultLang).subscribe(() => {
      });
  }

  ngOnInit() {
    // Set the system code once for the combined system
    this.sessionService.setSysCode('60');

    // Use ngOnInit instead of ngAfterViewInit
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          setTimeout(() => {
            this.isSpinnerVisible = true;
          });
        } else if (event instanceof NavigationEnd) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        } else if (event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        }
      },
      () => {
        setTimeout(() => {
          this.isSpinnerVisible = false;
        });
      }
    );

    this.listenToLoading();
  }

  /**
  * Listen to the loadingSub property in the LoadingService class. This drives the
  * display of the loading spinner.
  */
  listenToLoading(): void {
    this._loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.isSpinnerVisible = loading;
      });
  }

}
